import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewRefDirective } from '../../directives/view-ref.directive/view-ref.directive';
import { OffCanvasService } from '../../services/off-canvas.service';
import { OffCanvasChildComponent } from '../../model/off-canvas-child-component';

@Component({
    selector: 'off-canvas',
    templateUrl: './off-canvas.component.html',
    styleUrls: ['./off-canvas.component.scss']
})
export class OffCanvasComponent implements OnInit
{
    public active = false;
    public isClosable = true;
    //private factory: ComponentFactoryResolver;
    private instance: OffCanvasChildComponent;
    private readonly offCanvasService: OffCanvasService;
    @ViewChild(ViewRefDirective, { static: true }) public viewRef: ViewRefDirective;

    public constructor( offCanvasService: OffCanvasService)
    {
        //this.factory = componentFactoryResolver;
        this.offCanvasService = offCanvasService;
    }

    public ngOnInit(): void
    {
        this.offCanvasService.loaded.subscribe(() =>
        {
            this.active = true;
        });

        this.offCanvasService.open.subscribe(
            (item: { componentType: new () => OffCanvasChildComponent, data: any }) =>
            {
                const { componentType, data } = item;
                this.open(componentType, data);
            }
        );

        this.offCanvasService.hide.subscribe(() =>
        {
            this.close();
        });

        this.offCanvasService.requestEnableClose.subscribe((closable: boolean) =>
        {
            this.isClosable = closable;
        });


        this.offCanvasService.setOffCanvasViewContainerRef(this.viewRef);
    }

    private open<T extends OffCanvasChildComponent>(componentType: new () => T, data: any): void
    {
        /*
        let factory: ComponentFactory<T> = null;

        if (resolver)
        {
            factory = resolver.resolveComponentFactory(componentType);
        } else
        {
            factory = this.factory.resolveComponentFactory(componentType);
        }
*/
        this.clear();
        // const componentRef = this.viewRef.viewContainerRef.createComponent<T>(factory);
        const componentRef = this.viewRef.viewContainerRef.createComponent(componentType);
        componentRef.instance.data = data;
        this.instance = componentRef.instance;
    }

    private clear(): void
    {
        this.viewRef.viewContainerRef.clear();
    }

    public close(): void
    {
        this.active = false;
        this.clear();
    }

    public overlayClicked($event: MouseEvent): void
    {
        if (!this.instance.onOverlayClick())
        {
            return;
        }

        this.close();
    }

    public canvasClicked($event: MouseEvent): void
    {
        // $event.stopPropagation();
        // $event.preventDefault();
    }
}
